var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 22.1"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22.43 22.1H1.57A1.57 1.57 0 010 20.53v-7.45l5-8a1.54 1.54 0 011.33-.74h1.5a.52.52 0 010 1H6.32a.52.52 0 00-.44.25L1 13.38v7.15a.53.53 0 00.53.53h20.9a.53.53 0 00.53-.53v-7.15l-4.84-7.73a.52.52 0 00-.44-.25h-1.51a.52.52 0 110-1h1.51a1.54 1.54 0 011.32.7l5 8v7.45a1.57 1.57 0 01-1.57 1.57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14.8 16.36H9.2a1.56 1.56 0 01-1.53-1.26l-.27-1.33H1a.52.52 0 010-1h6.4a1 1 0 011 .84l.27 1.35a.53.53 0 00.51.42h5.6a.53.53 0 00.51-.42l.27-1.35a1 1 0 011-.84H23a.52.52 0 010 1h-6.4l-.27 1.35a1.56 1.56 0 01-1.53 1.26"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.85 0a.52.52 0 01.53.52v9.91a.53.53 0 01-1.05 0V.52a.52.52 0 01.52-.52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77 7.82a.52.52 0 01.37.16l1.71 1.71 1.72-1.71a.51.51 0 01.74 0 .52.52 0 010 .73l-2.46 2.46L9.4 8.71a.5.5 0 010-.73.49.49 0 01.37-.16"
  }))));
}
export default SvgDownload;